import React from "react";
import Swiper from "react-id-swiper";
// SCSS
import "swiper/css/swiper.css";
import PartnerBox2 from "./partnerBox2";
// Assets
import Partner01 from "../../assets/partners/fifa.png";
import Partner02 from "../../assets/partners/p&g.png";
import Partner03 from "../../assets/partners/FRMF.png";
import Partner04 from "../../assets/partners/addoha.png";
import Partner05 from "../../assets/partners/ainsoltan.png";
import Partner06 from "../../assets/partners/BO.png";
import Partner07 from "../../assets/partners/burgerking.png";
import Partner08 from "../../assets/partners/decathlon.png";
import Partner09 from "../../assets/partners/exelo.png";
import Partner10 from "../../assets/partners/gillette.png";
import Partner11 from "../../assets/partners/glovo.png";
import Partner12 from "../../assets/partners/h&s.png";
import Partner13 from "../../assets/partners/indomie.png";
import Partner14 from "../../assets/partners/itqan.png";
import Partner15 from "../../assets/partners/jet.png";
import Partner16 from "../../assets/partners/keito.png";
import Partner17 from "../../assets/partners/kenzup.png";
import Partner18 from "../../assets/partners/leecooper.png";
import Partner20 from "../../assets/partners/matu.png";
import Partner21 from "../../assets/partners/mg.png";
import Partner23 from "../../assets/partners/nescafe.png";

import Partner25 from "../../assets/partners/ram.png";

import Partner28 from "../../assets/partners/webhelp.png";

class MutipleSlidesPerView2 extends React.Component {
  state = {
    partners: [
      {
        preview: Partner01,
        id: "1",
      },
      {
        preview: Partner02,
        id: "2",
      },
      {
        preview: Partner03,
        id: "3",
      },
      {
        preview: Partner04,
        id: "4",
      },
      {
        preview: Partner05,
        id: "5",
      },
      {
        preview: Partner06,
        id: "6",
      },
      {
        preview: Partner07,
        id: "7",
      },
      {
        preview: Partner08,
        id: "8",
      },
      {
        preview: Partner09,
        id: "9",
      },
      {
        preview: Partner10,
        id: "10",
      },
      {
        preview: Partner11,
        id: "11",
      },
      {
        preview: Partner12,
        id: "12",
      },
      {
        preview: Partner13,
        id: "13",
      },
      {
        preview: Partner14,
        id: "14",
      },
      {
        preview: Partner15,
        id: "15",
      },
      {
        preview: Partner16,
        id: "16",
      },
      {
        preview: Partner17,
        id: "17",
      },
      {
        preview: Partner18,
        id: "18",
      },
      {
        preview: Partner20,
        id: "20",
      },
      {
        preview: Partner21,
        id: "21",
      },
      
      {
        preview: Partner23,
        id: "23",
      },
     
      {
        preview: Partner25,
        id: "25",
      },
     
      {
        preview: Partner28,
        id: "28",
      },
    ],
  };

  render() {
    let partnersRender = null;

    if (this.state.partners) {
      partnersRender = this.state.partners.map((partner) => (
        <div key={partner.id}>
          <PartnerBox2 partner={partner.preview} />
        </div>
      ));
    }

    const params = {
      slidesPerView: 3,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      breakpoints: {
        1200: {
          slidesPerView: 6,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        320: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
      },
    };
    
    return (
      <Swiper {...params}>
        {this.state.partners.map(partner => (
          <div key={partner.id}>
            <PartnerBox2 partner={partner.preview} />
          </div>
        ))}
      </Swiper>
    );  }
};
export default MutipleSlidesPerView2;
